(function () {
  var INTERVAL_MS = 3200;
  var SWIPE_THRESHOLD = 40;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(root) {
    var viewport = root.querySelector('[data-menvora-reviews-viewport]');
    var track = root.querySelector('[data-menvora-reviews-track]');
    var dots = root.querySelectorAll('[data-menvora-reviews-dot]');
    if (!viewport || !track) return;

    var slides = track.querySelectorAll('.menvora-ads-reviews__slide');
    var count = slides.length;
    if (count < 2) return;

    var index = 0;
    var timer = null;
    var reduced = prefersReducedMotion();
    var dragging = false;
    var startX = 0;
    var baseTranslate = 0;

    function slideStep() {
      if (!slides[0]) return 0;
      var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      return slides[0].offsetWidth + gap;
    }

    function translateForIndex(i) {
      return -i * slideStep();
    }

    function setIndex(next, animate) {
      index = (next + count) % count;
      track.classList.toggle('is-instant', animate === false);
      track.style.transform = 'translate3d(' + translateForIndex(index) + 'px, 0, 0)';

      for (var i = 0; i < dots.length; i++) {
        var active = i === index;
        dots[i].classList.toggle('is-active', active);
        dots[i].setAttribute('aria-current', active ? 'true' : 'false');
      }

      track.setAttribute('aria-label', 'Reseña ' + (index + 1) + ' de ' + count);
    }

    function next() {
      setIndex(index + 1, true);
    }

    function prev() {
      setIndex(index - 1, true);
    }

    function stopTimer() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startTimer() {
      stopTimer();
      if (reduced) return;
      timer = window.setInterval(next, INTERVAL_MS);
    }

    function resetTimer() {
      startTimer();
    }

    for (var d = 0; d < dots.length; d++) {
      (function (dotIndex) {
        dots[dotIndex].addEventListener('click', function () {
          setIndex(dotIndex, true);
          resetTimer();
        });
      })(d);
    }

    viewport.addEventListener(
      'touchstart',
      function (ev) {
        if (!ev.changedTouches || !ev.changedTouches[0]) return;
        dragging = true;
        startX = ev.changedTouches[0].clientX;
        baseTranslate = translateForIndex(index);
        track.classList.add('is-dragging');
        stopTimer();
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchmove',
      function (ev) {
        if (!dragging || !ev.changedTouches || !ev.changedTouches[0]) return;
        var deltaX = ev.changedTouches[0].clientX - startX;
        track.style.transform = 'translate3d(' + (baseTranslate + deltaX) + 'px, 0, 0)';
      },
      { passive: true }
    );

    function endDrag(clientX) {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      var diff = clientX - startX;
      if (Math.abs(diff) >= SWIPE_THRESHOLD) {
        setIndex(index, false);
        window.requestAnimationFrame(function () {
          if (diff < 0) next();
          else prev();
        });
      } else {
        setIndex(index, true);
      }
      resetTimer();
    }

    viewport.addEventListener(
      'touchend',
      function (ev) {
        if (!ev.changedTouches || !ev.changedTouches[0]) return;
        endDrag(ev.changedTouches[0].clientX);
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchcancel',
      function () {
        dragging = false;
        track.classList.remove('is-dragging');
        setIndex(index, true);
        resetTimer();
      },
      { passive: true }
    );

    root.addEventListener('mouseenter', stopTimer);
    root.addEventListener('mouseleave', startTimer);
    root.addEventListener('focusin', stopTimer);
    root.addEventListener('focusout', startTimer);

    window.addEventListener('resize', function () {
      setIndex(index, false);
    });

    setIndex(0, false);
    startTimer();
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-menvora-reviews-carousel]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
